import React from "react";
import FooterBottom from "./FooterBottom";
import FooterTop from "./FooterTop";
// import ScriptTag from "react-script-tag";

const Footer = () => {
  return (
    <>
      <FooterTop />
      <FooterBottom />
    </>
  );
};

export default Footer;
